// Light / dark mode for the LMS. Mirrors the IMS (getImsMode/applyMa2Mode): a
// persisted flag flips a `data-lms-mode` attribute on <html>; index.css defines
// the light tokens on :root and the dark overrides on :root[data-lms-mode="dark"],
// so every var(--lms-*) surface re-themes with no component changes. The CMS
// brand bridge (useBrand) still wins for any key it sets.
const KEY = 'lms_mode';

export function getMode() {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyMode(mode) {
  const m = mode === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-lms-mode', m);
}

export function toggleMode() {
  const next = getMode() === 'dark' ? 'light' : 'dark';
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* ignore quota/privacy errors */
  }
  applyMode(next);
  return next;
}

// Instant paint on load, before React mounts, so there is no light→dark flash.
applyMode(getMode());
